import { logWarning } from '../utils/loggingUtil';
import AdvertorialSas from './sasProvider';
import AdvertorialGlobal from './sasGlobalProvider';
var AdvertorialAdProvider = {};
AdvertorialAdProvider.PROVIDERS = {
  SAS: AdvertorialSas,
  GLOBAL: AdvertorialGlobal
};
AdvertorialAdProvider.DEFAULT_PROVIDER = AdvertorialSas; // TODO: need to find a place for this other than window

AdvertorialAdProvider.getCode = function () {
  return window.ruiAdProvider || null;
};

AdvertorialAdProvider.getCurrent = function () {
  return AdvertorialAdProvider.PROVIDERS[AdvertorialAdProvider.getCode()] || AdvertorialAdProvider.DEFAULT_PROVIDER;
};

AdvertorialAdProvider.isDefault = function () {
  var isDefault = AdvertorialAdProvider.getCurrent() === AdvertorialAdProvider.DEFAULT_PROVIDER;

  if (!isDefault) {
    logWarning("Not using default ad provider. Using ".concat(AdvertorialAdProvider.getCode(), "."));
  }

  return isDefault;
};

export default AdvertorialAdProvider;
//# sourceMappingURL=index.js.map